import styled from 'styled-components';

export const PinContainer = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 16px;
    margin: 24px 0;
    
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const PinInputWrapper = styled.div`
    width: 300px;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const PinButtonWrapper = styled.div`
    margin-bottom: 0;
`;

export const OrderSection = styled.div`
    display: grid;
    gap: 15px;
    width: 95%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 18px;
`;

export const SectionCard = styled.div`
    background: white;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    padding: 24px;
`;

export const StyledTableWrapper = styled.div`
    max-height: 450px;
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    
    /* Personalización del scrollbar para webkit */
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    &::-webkit-scrollbar-track {
        background: #f8f8f8;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #d0d0d0;
        border-radius: 4px;
        transition: background 0.2s;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #a0a0a0;
    }
    
    /* Hacer que el header se mantenga fijo al hacer scroll */
    table {
        width: 100%;
        min-width: 600px;
        border-collapse: separate;
        border-spacing: 0;
    }
    
    thead {
        position: sticky;
        top: 0;
        z-index: 2;
    }
    
    tbody tr {
        transition: background-color 0.15s ease;
        
        &:hover {
            background-color: #f9f9f9;
        }
    }
    
    /* Responsive */
    @media (max-width: 768px) {
        max-height: 350px;
        border-radius: 6px;
        
        table {
            min-width: 500px;
        }
    }
`;

export const SectionTitle = styled.div`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #333;
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 32px;
    margin-top: 24px;
`;

export const ErrorAlert = styled.div`
    background-color: #F7E6E1;
    border: 1px solid #BD2C00;
    border-radius: 8px;
    padding: 16px 20px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    animation: slideDown 0.3s ease-out;

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const ErrorContent = styled.div`
    flex: 1;
`;

export const ErrorTitle = styled.div`
    color: #BD2C00;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
`;

export const ErrorMessage = styled.div`
    color: #BD2C00;
    font-size: 13px;
    line-height: 1.5;
`;

export const SuccessAlert = styled.div`
    background-color: #E6F5F1;
    border: 1px solid #B6DFD6;
    border-radius: 8px;
    padding: 16px 20px;
    margin-top: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    animation: slideDown 0.3s ease-out;

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const SuccessContent = styled.div`
    flex: 1;
`;

export const SuccessTitle = styled.div`
    color: #22A889;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
`;

export const SuccessMessage = styled.div`
    color: #22A889;
    font-size: 13px;
    line-height: 1.5;
`;

// Fila superior: PIN + botón
export const PinTopRow = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
    margin: 24px 0 16px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

// Caja gris full-width con el rango de fechas (Desde / Hasta) + Limpiar
export const DateFilterBox = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
    padding: 12px 16px;
    background: #f9fafb;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    margin-bottom: 16px;
`;

export const DateFilterIcon = styled.span`
    display: flex;
    align-items: center;
    height: 34px;
`;

export const FilterCounter = styled.div`
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
    strong { color: #262626; }
`;

// ─── Rincón Jumbo: tabla de detalle agrupada por orden (rowspan) ───────────
export const GroupedTableWrapper = styled.div`
    max-height: 480px;
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid #e8e8e8;
    border-radius: 8px;

    &::-webkit-scrollbar { width: 8px; height: 8px; }
    &::-webkit-scrollbar-track { background: #f8f8f8; border-radius: 4px; }
    &::-webkit-scrollbar-thumb { background: #d0d0d0; border-radius: 4px; }
    &::-webkit-scrollbar-thumb:hover { background: #a0a0a0; }

    table {
        width: 100%;
        min-width: 720px;
        border-collapse: separate;
        border-spacing: 0;
        font-size: 13px;
    }

    thead {
        position: sticky;
        top: 0;
        z-index: 2;
    }

    th {
        background: #fafafa;
        color: #666;
        font-weight: 600;
        text-align: left;
        padding: 12px 16px;
        border-bottom: 1px solid #e0e0e0;
        white-space: nowrap;
    }

    td {
        padding: 11px 16px;
        color: #262626;
        vertical-align: middle;
    }

    td.cell-orden { font-weight: 600; }
    td.cell-detalle { color: #444; }

    .eye-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        line-height: 0;
    }
`;

// Nuevo wrapper para scroll en tablas
export const ScrollableTableWrapper = styled.div`
    max-height: 500px;
    overflow-y: auto;
    
    /* Personalización del scrollbar para webkit */
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #999;
    }
`;
